export const locale = {
  lang: 'it',
  data: {
    DEBTOR: {
      DEBTOR: 'Debitore',
      SEARCH_CLIENTS: 'Cerca tra i tuoi clienti',
      ADD_NEW: 'Aggiungi nuovo',
      BUSINESS_NAME: 'Ragione sociale',
      TAX_CODE_PREFIX: 'Nazione',
      TAX_CODE: 'Codice fiscale',
      CERTIFIED_EMAIL: 'Email certificata (PEC)',
      CONTACT_DATA: 'Indica la persona che può confermare la fattura',
      FIRST_NAME: 'Nome',
      LAST_NAME: 'Cognome',
      EMAIL: 'Email',
      PHONE: 'Telefono',
    },
    INVOICE: {
      INVOICE: 'Fattura',
      NUMBER: 'Numero Fattura',
      INVOICE_DATE: 'Data fattura',
      DUE_DATE: 'Data Scadenza',
      MAX_FILE_SIZE: 'Dimensione massima 20 MB',
      AMOUNT: 'Importo',
      INSTALLMENTS: 'Dettaglio rate',
      INSTALLMENT_NUMBER: 'Numero rata',
      UPLOAD_INVOICE: 'Clicca qui per caricare la fattura nel formato PDF di cortesia',
      DOWNLOAD_INVOICE: 'Scarica fattura pdf',
      REPLACE_INVOICE: 'Sostituisci fattura pdf',
      INVOICE_PDF: 'Fattura pdf',
      SNACKBAR: {
        DEBTOR_ADDED: 'Cliente aggiunto con successo!',
        INVOICE_ADDED: 'Fattura aggiunta con successo!',
        INVOICE_EDITED: 'Fattura modificata con successo!',
        ADDED: 'Fattura aggiunta con successo!',
        DELETED: 'Fattura eliminata con successo!',
        NOT_DELETED: 'Errore: fattura non eliminata!',
        ATTACHMENT_ERROR: 'Errore caricamento file',
        ERROR: 'Errore: riprova!',
        ATTACHMENT: 'Devi caricare almeno una fattura elettronica XML e tutti i documenti obbligatori.',
        DUE_DATE: 'Devi inserire una data di scadenza successiva a domani',
        ACTIVATED: 'Devi essere abilitato dal team CashMe per poter pubblicare una fattura',
      },
    },
    AUCTION: {
      AUCTION: 'Asta',
      DAY_DELAY: 'Numero giorni ritardo medio',
      DAY_DELAY_HINT: 'Attenzione: modificando questo campo verrà aggiornato il valore minimo di vendita',
      SELL_INFO: 'Imposta il valore minimo a cui vorrai cedere il tuo credito (Offerta minima).',
      RANGE_INFO:
        'In base allo storico delle transazioni già effettuate sulla piattaforma,\n' +
        'si suggerisce un range di prezzo minimo compreso tra',
      AND: 'e',
      MINIMUM_BID: 'Valore minimo di vendita',
      SELL_NOW_PRICE: 'Valore di Sell Now',
      VALUE_HINT: 'Valore suggerito',
      DISCOUNT_APPLIED: 'Sconto applicato',
    },
    OTHER_DOC: {
      MANDATORY_DOC: 'Documenti obbligatori',
      LOAD_DOC: 'Caricare i seguenti documenti',
      MORE_DOC: 'Altri documenti obbligatori',
      OTHER_DOC: 'Altri documenti',
      INFO:
        'Completa la pratica allegando altri documenti che ritieni utili al fine di velocizzare l\'ammissione della fattura all\'asta\n' +
        '(es. contratto di fornitura, eventuale bolla di accompagnamento).',
      DELIVERY_NOTE: 'DDT firmato dal destinatario',
      DELIVERY_NOTE_CARRIER: 'DDT firmato dal vettore',
      CUSTOMER_ORDER: 'Ordine cliente',
      SUPPLY_CONTRACT: 'Contratto di fornitura',
      SDI_DELIVERY_RECEIPT: 'Ricevuta invio SDI',
      XML_INVOICE: 'Fattura elettronica in formato xml',
      XML_INVOICE_DOC: 'Fattura elettronica in formato xml',
      CLIENT_LEDGER: 'Partitario cliente',
      OTHER: 'Altro',
      CUSTOMER_ORDER_CONFIRMATION: 'Conferma ordine',
      WORK_PROGRESS: 'Sal - Stato avanzamento lavori',
      RELEASE_GUARANTEE_LETTER: 'Lettera di svincolo Factor',
      CUSTOMER_EMAIL_EXCHANGE: 'Scambio email con il cliente',
      ADD: 'Aggiungi',
      DELETE: 'Vuoi eliminare questo allegato?',
      NO: 'No',
      YES: 'Si',
      LABEL: {
        DELIVERY_NOTE: '# DDT',
        CUSTOMER_ORDER: '# Ordine',
        SUPPLY_CONTRACT: '# Contratto',
      },
      EXPIRATION_DATE_WARNING: 'Partitario cliente scaduto',
      MAX_FILE_SIZE: 'Dimensione massima per file: 20MB',
    },
    ACTION: {
      CANCEL: 'Annulla',
      NEXT: 'Prossimo',
      SAVE: 'Salva',
      END: 'Fine',
      SEND: 'Pubblica',
      PREVIOUS: 'Precedente',
      CONTINUES_LATER: 'Continua piú tardi',
      CONTINUES_LATER_INFO: 'Se vuoi salvare una bozza e ricontrollare i dati in un altro momento clicca su',
    },
    ERROR: {
      REQUIRED: 'Campo obbligatorio',
      INVALID: 'Valore invalido',
      EMAIL: 'Inserisci un\'email valida',
      TAX_CODE: {
        INVALID: 'C.F. invalido',
        FORMAT: 'Formato errato',
      },
      PHONE: 'Inserisci un numero di telefono valido',
      DATE: 'Inserisci una data valida',
      MINIMUM_BID_1: 'Il valore deve essere compreso tra',
      MINIMUM_BID_2: 'e',
      SELL_NOW:
        'Il valore deve essere compreso tra il valore minimo di vendita e l\'importo fattura',
      ATTACHMENT: 'Devi caricare almeno un allegato di categoria SDI e uno di un\'altra categoria',
    },
  },
};
